export default __webpack_public_path__ + "static/media/iModX-C.dc531a76.svg";